// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"7e29910d","465":"ba54bc52","565":"7dd80e64","570":"54505413","870":"c29a1db1","890":"f97f83fe"}[chunkId] + ".chunk.css";
};